// globalStyles.js
import {createGlobalStyle} from 'styled-components';

// scale out entire web page for better proportions
const GlobalStyles = createGlobalStyle`
html { 
    transform: scale(0.65);
    transform-origin: 0 0;
    width: 154%;
  }  
`;

export default GlobalStyles;
